module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-plus-fill-db75c009.svg";